export default __webpack_public_path__ + "static/media/NoirPro-Light.b9cb1c27.woff";